import { mapTaskType, TaskType, useUpdateTask } from '@api';
import { TaskFormSchemaType, useNotification } from '@common';
import { AxiosError } from 'axios';
import { getUpdateTaskData } from './helpers';

const TRANS_KEY = 'NOTIFICATIONS.UPDATE_TASK';

type UseSubmitUpdateTaskReturnType = {
  submitUpdateTask: (
    taskId: string,
    data: TaskFormSchemaType
  ) => Promise<TaskType>;
};

export const useSubmitUpdateTask = (): UseSubmitUpdateTaskReturnType => {
  const { mutateAsync: updateTask } = useUpdateTask();
  const { showSuccess, showError } = useNotification();

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_KEY}.SUCCESS.TITLE`,
      message: `${TRANS_KEY}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_KEY}.ERROR.TITLE`,
      message: `${TRANS_KEY}.ERROR.MESSAGE`,
      error,
    });
  };

  const submitUpdateTask = async (
    taskId: string,
    data: TaskFormSchemaType
  ): Promise<TaskType> => {
    const response = await updateTask(
      {
        taskId,
        data: getUpdateTaskData({ values: data }),
      },
      { onSuccess, onError }
    );

    return mapTaskType(response.data);
  };

  return { submitUpdateTask };
};
